import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Inbox, Briefcase, Layers, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin", label: "Leads", icon: Inbox, end: true },
  { to: "/admin/case-studies", label: "Case Studies", icon: Briefcase },
  { to: "/admin/services", label: "Services", icon: Layers },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate("/gis-admin");
  };

  return (
    <div className="min-h-screen bg-background flex" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-64 shrink-0 border-r border-white/10 bg-[#070810] hidden md:flex flex-col fixed inset-y-0">
        <div className="p-6 border-b border-white/10">
          <img src="/logo-light.png" alt="Growing IT Solutions" className="h-8 w-auto" />
        </div>
        <nav className="flex-1 p-4 space-y-1">
          <p className="text-xs uppercase tracking-wider text-slate-600 font-semibold px-3 mb-3 flex items-center gap-2">
            <LayoutDashboard className="w-3.5 h-3.5" /> Dashboard
          </p>
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-primary/15 text-primary border-l-2 border-primary" : "text-slate-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <n.icon className="w-4 h-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-3 py-2.5 text-sm text-slate-400 hover:text-white transition-colors">
            <ExternalLink className="w-4 h-4" /> View site
          </Link>
          <button onClick={onLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-3 py-2.5 text-sm text-slate-400 hover:text-red-400 transition-colors">
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="flex-1 md:ml-64">
        {/* Mobile top bar */}
        <div className="md:hidden border-b border-white/10 bg-[#070810] px-5 py-4 flex items-center justify-between sticky top-0 z-20">
          <img src="/logo-light.png" alt="logo" className="h-7 w-auto" />
          <div className="flex items-center gap-3">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `text-xs ${isActive ? "text-primary" : "text-slate-400"}`}>{n.label}</NavLink>
            ))}
            <button onClick={onLogout} className="text-slate-400"><LogOut className="w-4 h-4" /></button>
          </div>
        </div>
        <div className="p-6 sm:p-10">
          <div className="mb-8">
            <p className="text-sm text-slate-500">Welcome back,</p>
            <h1 className="font-heading text-2xl font-semibold text-white">{user?.name || "Admin"}</h1>
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
